import { render, staticRenderFns } from "./shoporder.vue?vue&type=template&id=4c797d1c&scoped=true&"
import script from "./shoporder.vue?vue&type=script&lang=js&"
export * from "./shoporder.vue?vue&type=script&lang=js&"
import style0 from "./shoporder.vue?vue&type=style&index=0&id=4c797d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c797d1c",
  null
  
)

export default component.exports